type GtagEventParams = Record<string, any>;

export function sendGtag(eventName: string, params: GtagEventParams = {}) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    } else {
      console.warn(
        `[sendGtag] gtag not initialized yet. Event skipped: ${eventName}`,
        params
      );
    }
  } catch (e) {
    console.log("gtag error:", e);
  }
}
